'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Directive affichant l'image associé à une contrepartie.
 *
 * Peut être utilisée de deux façon :
 *
 * 1/ en passant la reference de la contrepartie
 *    via <... contrepartie="ref" ...
 *
 * 2/ en passant les valeurs id et type de la contrepartie
 *    via <... contrepartie-id="{{}}" contrepartie-type="{{}}" ...
 */
ngModule.directive("logoContrepartie", function (security, urlUtils) {
  var sizeMap = {
    big: 100,
    small: 50,
    icon: 24
  };
  return {
    restrict: "E",
    replace: true,
    scope: false,
    template: '<img img-scale img-height="40" class="contrepartie-logo">',
    link: function link($scope, $el, $attrs, ctrl) {
      var unwatch;
      if ($attrs.contrepartie) {
        unwatch = $scope.$watch($attrs.contrepartie, function (contrepartie) {
          if (contrepartie == null) {
            return;
          }
          $el.attr("title", contrepartie.libelleJuridique);
          // Le type est quelque fois présent dans l'attribut type, quelque fois dans typeContrepartie..
          ctrl.setContrepartieInfo(contrepartie.id, contrepartie.type || contrepartie.typeContrepartie);
          unwatch();
        });
      } else if ($attrs.contrepartieId) {
        unwatch = $attrs.$observe("contrepartieId", function () {
          ctrl.setContrepartieInfo($attrs.contrepartieId, $attrs.contrepartieType);
          unwatch();
        });
      }
    },
    controller: function controller($scope, $element, $attrs) {
      var ctrl = this;
      ctrl.setContrepartieInfo = function (cpId, cpType) {
        var iconSize = $attrs.size || "small";
        var iconDimension = sizeMap[iconSize] || sizeMap["small"];
        var isBigIcon = iconDimension >= 100;
        $element.height(iconDimension + "px");
        $element.width(iconDimension + "px");
        $attrs.$set("imgHeight", iconDimension);
        $attrs.$set("imgWidth", iconDimension);
        if (cpId && cpId !== "$NO_ID$") {
          var params = _.extend(security.getTokens(), {
            id: cpId,
            type: cpType
          });
          var url = urlUtils.addParams("/rest/contreparties/logo/" + (isBigIcon ? "big" : "small"), params);
          $element.attr("src", url);
        } else {
          $element.attr("src", "/images/no_image.png");
          $element.attr("title", "Pas de contrepartie rattachée");
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/pills/logoContrepartie.js
// module id = 2983
// module chunks = 13